import "core-js/modules/es.array.concat.js";
import React from 'react';
export var StarIcon = function StarIcon(_ref) {
  var width = _ref.width,
    color = _ref.color;
  return React.createElement("svg", {
    width: width,
    height: width,
    viewBox: "0 0 ".concat(width + 1, " ").concat(width + 1),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M7.99998 0.666656C8.25372 0.666656 8.48547 0.810705 8.59778 1.03824L10.5028 4.89763L14.7631 5.52033C15.0141 5.55703 15.2226 5.73303 15.3008 5.97437C15.3791 6.21571 15.3135 6.48054 15.1318 6.65756L12.0497 9.65957L12.7771 13.9006C12.8199 14.1508 12.7171 14.4035 12.5118 14.5527C12.3065 14.7018 12.0343 14.7215 11.8097 14.6034L7.99998 12.5999L4.19028 14.6034C3.96567 14.7215 3.69347 14.7018 3.48816 14.5527C3.28284 14.4035 3.18001 14.1508 3.22291 13.9006L3.9503 9.65957L0.868157 6.65756C0.686411 6.48054 0.620896 6.21571 0.699148 5.97437C0.7774 5.73303 0.985853 5.55703 1.23689 5.52033L5.49714 4.89763L7.40217 1.03824C7.51449 0.810705 7.74623 0.666656 7.99998 0.666656Z",
    fill: color || '#eee'
  }));
};